module.exports = __webpack_public_path__ + "static/media/Source Info.4669a1a3.txt";